import React from "react";
import { Mail, Shield, Lock, Eye, Database, Globe, Scale, Clock, X } from "./Icons";

const PrivacyPolicyModal = ({ isOpen, onClose, mobile, countryCode }) => {
  if (!isOpen) return null;

  return (
    // <div className="fixed inset-0 z-[70] flex items-center justify-center md:p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300">
    <div
      className="fixed inset-0 flex items-center justify-center md:p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300"
      style={{ zIndex: "100" }}
    >
      {/* <div className="glass w-full h-full md:max-w-4xl md:max-h-[85vh] md:rounded-[2.5rem] overflow-hidden flex flex-col border-white/10 shadow-2xl"> */}
      <div
        className="glass w-full h-full md:max-w-4xl md:max-h-[85vh] rounded-[2rem] overflow-hidden flex flex-col border-white/10 shadow-2xl"
        // style={{ padding: mobile ? "" : "3rem" }}
      >
        <div className="px-6 py-4 md:px-8 md:py-6 border-b border-white/5 flex justify-between items-center bg-slate-900/40">
          <div className="flex items-center gap-3">
            <div className="md:w-10 md:h-10 bg-indigo-600 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-500/20">
              <Shield className="text-white w-6 md:h-6" />
            </div>
            <h2 className="text-xl font-bold text-white tracking-tight">Privacy Policy</h2>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full transition-all">
            <X className="md:h-6 w-6 text-slate-400" />
          </button>
        </div>

        {/* <div className="flex-1 overflow-y-auto p-6 md:p-10 space-y-12"> */}
        <div className="flex-1 overflow-y-auto md:p-10 space-y-12">
          <section className="space-y-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-sm font-medium">
              <Shield className="w-4 md:h-4" />
              <span>Privacy Policy</span>
            </div>
            <h1 className="text-4xl text-white md:text-5xl font-bold tracking-tight">
              Your Privacy <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-emerald-400">
                Matters.
              </span>
            </h1>
            <p className="text-lg text-slate-400 leading-relaxed max-w-2xl">
              This Privacy Policy describes how aiComposz collects, uses, and protects your
              information when you use aicomposz.com.
            </p>
          </section>

          <div className="prose prose-invert prose-indigo mt-30 max-w-none space-y-8 text-slate-300">
            {/* <div className="p-8 rounded-3xl bg-slate-800/40 border border-slate-700/50"> */}
            <div
              className="rounded-3xl bg-slate-800/40 border border-slate-700/50"
              style={{
                margin: mobile ? "" : "1rem",
                padding: mobile ? "15px" : "2rem",
                marginTop: mobile ? "15px" : "",
              }}
            >
              <p className="text-sm leading-relaxed">
                This Privacy Policy (“Privacy Policy”) describes how aiComposz owned & operated by{" "}
                {countryCode !== "IN" ? "Composz LLC" : "Life Colors"} having its registered office
                at{" "}
                {countryCode !== "IN"
                  ? "121, HAUT BRION AVE, NEWARK, DE 19702"
                  : "#9, 4th Cross, Kothanur Main Road, Bangalore 560 062."}{" "}
                (hereinafter referred to as "aiComposz",{" "}
                {countryCode !== "IN" ? "“Composz”" : "“Life Colors”"}, “we”, “our” or “us”)
                collects, uses, stores, shares and protects the user information in connection with
                the user’s (hereinafter referred to as “you”, “your” or “user”) use of our services
                throughout the Platform. By accessing our website or using our Services, or by
                signing up with us, you agree to our Terms and Conditions and Privacy Policy, both
                of which are electronic record in the form of electronic contract and do not require
                any physical, electronic or digital signature and is a legally binding agreement
                between You and our Company. Further, by sharing your details with us, you also
                agree to receive e-mails including newsletter, campaign updates, advertisements,
                inter-alia with regard to our Platform. IF YOU DO NOT AGREE TO BE BOUND BY THIS
                AGREEMENT YOU MAY NOT ACCESS OR USE THE PLATFORM.
              </p>
            </div>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                <Eye className="w-6 md:h-6 text-indigo-400" />
                What does this policy cover?
              </h2>
              <p className="text-sm">
                Summary: This policy sets out how aiComposz collects, stores, shares and uses the
                information that we collect about you when you use the aiComposz Services. This
                policy also explains the choices that you can make about the way that we use your
                information. This Privacy Policy covers our usage of material as mentioned in the
                policy that is shared by you with us in furtherance of using the Service. This
                policy also covers treatment of any personally identifiable information shared with
                us. This policy does not apply to the activities of organizations not owned or
                controlled by us, or to people who are not employed or managed by us.
              </p>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                <Database className="w-6 md:h-6 text-emerald-400" />
                1. Information we collect and its use
              </h2>

              <div className="space-y-4">
                <h3 className="text-xl font-bold text-indigo-400">
                  a. Information you provide us directly - Personally Identifiable Information
                </h3>
                <p className="text-sm">
                  In order for you to use our Platform and Services, we might require you to input
                  on our Platform certain personal information which may include without limitation
                  your location, name, address, contact details, professional details, payment
                  details, bank account numbers, in certain cases, your Personal Account Number and
                  other personal information that may be required for the use of the Platform from
                  time to time. If you communicate with us by, for example, e-mail or letter, any
                  information provided in such communication may also be collected by us. We collect
                  messages you send us through the Service, and may collect information you provide
                  in User Content you post to the Service (such as text and photos you upload to use
                  in your designs). We use this information to operate, maintain, and provide the
                  features and functionality of the Service to you, to correspond with you, and to
                  address any issues you raise about the Service. In case you don’t wish to provide
                  your personal identifiable information to us, you might not be able to access our
                  Platform or use our Service.
                </p>

                <h3 className="text-xl font-bold text-indigo-400">
                  b. Non-Personally Identifiable Information
                </h3>
                <p className="text-sm">
                  We also collect non-personally identifying information that your browser makes
                  available whenever you visit the Website. This information includes without
                  limitation your IP Address, Domain Servers, hardware specs, browser type, browser
                  language, the date and time of your query and one or more cookies that may
                  uniquely identify your browser, inter-alia, COOKIES. A cookie is a text file
                  stored by a web server on a computer or mobile device to collect standard internet
                  log information and visitor behaviour information. Cookies are unique to the
                  browsers or mobile application you use, and enable websites to store data such as
                  your preferences or items in your shopping cart. Cookies allow websites/platforms
                  to remember your settings such as language, font size on your computer or mobile
                  device, or other browser preferences. We may collect information from you
                  automatically through cookies or similar technology when you visit our website to
                  improve user experience. If you want to disable cookies you need to change your
                  website browser setting accordingly. The settings depend upon the browser you are
                  using.
                </p>

                <h3 className="text-xl font-bold text-indigo-400">c. Location Data</h3>
                <p className="text-sm">
                  We receive information from you that helps us approximate your location. We may,
                  for example, use an address submitted by you while setting up your profile, IP
                  Address, domain servers or hardware MAC address received from your browser or
                  device to determine your approximate location and other information with respect
                  to your device, interaction of Your device with the Platform (“Traffic Data”). We
                  may also collect location information from devices in accordance with the consent
                  process provided by your device.
                </p>

                <h3 className="text-xl font-bold text-indigo-400">d. Log file information</h3>
                <p className="text-sm">
                  Log file information is automatically reported by your browser or mobile device
                  each time you access the Service. When you use our Service, our servers
                  automatically record certain log file information. These server logs may include
                  anonymous information such as your web request, Internet Protocol (“IP”) address,
                  browser type, referring / exit pages and URLs, number of clicks and how you
                  interact with links on the Service, domain names, landing pages, pages viewed, and
                  other such information.
                </p>
              </div>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                <Lock className="w-6 md:h-6 text-indigo-400" />
                2. How do we use your collected Information?
              </h2>
              <p className="text-sm">
                Any of the information we collect from you may be used in one of the following ways:
              </p>
              <ul className="list-disc pl-6 space-y-4 text-sm">
                <li>
                  <strong>Creating an Account:</strong> We use your personal data such as your name,
                  Date of birth, email address and so on, to help set up your account and, if
                  necessary, to contact you (according to your preferences) via your registered
                  contact information in connection with the management and operation of your
                  account.
                </li>
                <li>
                  <strong>To improve our Platform:</strong> We continually strive to improve our
                  Platform offerings and develop new Service offerings for the Platform, this
                  enhancement is based on the information and feedback we receive from you and
                  further we may use the information for the further development of growth and
                  business strategies and data collection.
                </li>
                <li>
                  <strong>Providing you with the required Service:</strong> We use the information
                  that you provide us to provide the Service to you. This includes allowing you to
                  log in to aiComposz, operating and maintaining the Service, giving you access to
                  your designs and billing you for transactions that you make via the Service. We
                  may also use information we collect about you automatically to remember
                  information about you so that you will not have to re-enter it during your visit
                  or the next time you visit the site.
                </li>
                <li>
                  <strong>To monitor and analyse use of the Service/Platform:</strong> This is done
                  to ensure smooth running of the Services technical administration and to increase
                  the Service functionality and user-friendliness and to provide you with a reliable
                  environment.
                </li>
                <li>
                  <strong>For data analytics:</strong> We use information about you to help us
                  improve the aiComposz Service and our users’ experience, including by monitoring
                  aggregate metrics such as total number of visitors, traffic, and demographic
                  patterns.
                </li>
                <li>
                  <strong>To improve customer service:</strong> Your information helps us to more
                  effectively respond to your user service requests and support needs and to easily
                  communicate with and keep you updated of our latest updates to our Services and
                  special offers.
                </li>
                <li>
                  <strong>To promote and drive engagement:</strong> We use your contact information
                  to get in touch with you about features and offers relating to the Service that we
                  think you would be interested in. We also use information we collect about you to
                  make sure that you get the most relevant offers and promotions based on your use
                  of the Service, and your preferences.
                </li>
                <li>
                  <strong>Relationship Management:</strong> We may use the information to manage our
                  relationship with our partners, investors and advertisers, if required, however,
                  the user can reach out to us at team@aicomposz.com if it wants us to cease sharing
                  its information to send periodic emails: The email address as provided by you, may
                  be used to send in information and updates pertaining to the Platform and
                  Services, in addition to receiving occasional Company news, updates, related
                  service information, etc. to be able to tailor the Services to one’s specific
                  needs if feasible, for convenience of users and communication with them, and as
                  may be required by law.
                </li>
                <li>
                  <strong>User Security:</strong> To maintain privacy and security of your account
                  and its details thereof.
                </li>
                <li>
                  <strong>Legal Compliance:</strong> aiComposz will use or disclose your information
                  where we reasonably believe that such action is necessary to: comply with the law
                  and the reasonable requests of law enforcement; to enforce our Terms of Use or to
                  protect the security or integrity of our Service; and/o to exercise or protect the
                  rights, property, or personal safety of aiComposz, our Users or others.
                </li>
                <li>
                  <strong>Dispute Resolution:</strong> We may also need to process Personal Data
                  about you to meet our internal administration requirements and for matters such as
                  dispute resolution.
                </li>
              </ul>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                <Globe className="w-6 md:h-6 text-emerald-400" />
                3. Disclosing your information
              </h2>
              <ul className="list-disc pl-6 space-y-4 text-sm">
                <li>
                  We reserve the right to disclose personally identifiable information and/or
                  non-personally-identifiable information which we believe, in good faith, is
                  appropriate or necessary to enforce our terms of use, take precautions against
                  liability, to investigate and defend ourselves against any third-party claims or
                  allegations, to assist government enforcement agencies, to protect the security or
                  integrity of our web site, and to protect the rights, property, or personal safety
                  of ours, our users or others.
                </li>
                <li>
                  We do not transfer your personally identifiable information to outside third
                  parties, unless, such transfer is essential to the usage of services by you on the
                  Platform.
                </li>
                <li>
                  The information may be shared, only to the extent required, with trusted third
                  parties including without limitation, our group and other affiliated companies,
                  payment service providers, auditors, event collaboration partners, Licensing
                  authorities, governmental and regulatory bodies, in accordance with applicable
                  laws and regulations, auditors, financers and any party/entity who assists us in
                  operating our Platform, conducting our business, or servicing you, so long as
                  those parties agree to keep this information confidential.
                </li>
                <li>
                  We may use and disclose to third parties, information we collect in aggregated,
                  non-personally identifiable form for research and informational purposes and to
                  help us make sales, marketing and business decisions for marketing, advertising,
                  or other uses.
                </li>
                <li>
                  We may share Personal Data with third parties (which will also be acting as
                  controllers in respect of that Personal Data) with whom we are under a legal duty
                  to do so or if it is required to enforce or apply our contracts or to protect the
                  operation of our website, or the rights, property or safety of us or others.
                </li>
                <li>We do not sell or trade your personal information.</li>
                <li>
                  Some of the third parties that aiComposz may share your personal information with
                  include providers who assist aiComposz with functions such as: Billing; Customer
                  support and customer management; Email services; Hosting and storage; Analytics
                  etc.
                </li>
                <li>
                  We might also share your information with third parties in certain circumstances,
                  such as in a situation where we are required to do so as a result of a court
                  order, subpoena or other legal requirement.
                </li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white">4. Change of Control</h2>
              <p className="text-sm">
                In the event of the change of control of the Company or a business transition, such
                as, reorganization, merger, demerger, acquisition, or sale of assets, your
                information may be transferred to the successor organization. You will be notified
                of any such deal and your information would remain subject to the commitments
                contained in this Privacy Policy until such time as this Privacy Policy is updated
                or amended by the acquiring party upon notice to you.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white">5. Information Storage</h2>
              <ul className="list-disc pl-6 space-y-4 text-sm">
                <li>
                  <strong>Permission to Use Information:</strong> By submitting your personal
                  information, you agree to its transfer, storage or processing. We will take all
                  steps reasonably necessary to ensure that your data is treated securely and in
                  accordance with this Privacy Policy.
                </li>
                <li>
                  <strong>Data Retention:</strong> We only retain your personal data for as long as
                  your account is active or otherwise for a limited period of time as long as we
                  need to fulfil the purposes for which we had initially collected it, unless
                  otherwise required by law. We will retain and use information as necessary to
                  comply with our legal obligations, resolve disputes and enforce our agreement as
                  required by the applicable law.
                </li>
                <li>
                  <strong>Password:</strong> Where we have given you (or where you have chosen) a
                  password which enables you to access certain Services or specific areas of the
                  Platform, you are responsible for keeping this password confidential. We ask that
                  you do not share your password with anyone.
                </li>
                <li>
                  <strong>Disclaimer:</strong> Unfortunately, the transmission of information via
                  the Internet is not completely secure. Although we will do our best to protect
                  your personal data, we cannot guarantee the security of your data transmitted to
                  us via the Internet; any such transmission is at your own risk.
                </li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white">6. Keeping your information safe</h2>
              <p className="text-sm">
                aiComposz cares about the security of your information, and uses appropriate
                safeguards to preserve the integrity and security of all information collected
                through the Service. To protect your privacy and security, we take reasonable steps
                (such as requesting a unique password) to verify your identity before granting you
                access to your account. You are responsible for maintaining the secrecy of your
                unique password and account information, and for controlling access to your email
                communications from aiComposz, at all times. However, aiComposz cannot ensure or
                warrant the security of any information you transmit to aiComposz or guarantee that
                information on the Service may not be accessed, disclosed, altered, or destroyed.
                Your privacy settings may also be affected by changes to the functionality of third
                party sites and services that you add to the aiComposz Service, such as social
                networks. aiComposz is not responsible for the functionality or security measures of
                any third party.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white">
                7. Retention, Modification and Deletion of Personally Identifiable Information
              </h2>
              <ul className="list-disc pl-6 space-y-4 text-sm">
                <li>
                  <strong>Retention:</strong> If you have registered with an account on our
                  Platform, we will retain your Personal Information during the period your account
                  is active. In addition, we will retain your Personal Data for additional periods,
                  to enable us to meet our legal obligations under applicable laws or regulations,
                  such as the applicable regulations, Know-Your-Customer and Anti-Money Laundering
                  regulations. In addition, we may retain your Personal Information for longer
                  periods, provided that retaining such information is necessary for our legitimate
                  interests, such as fraud prevention and record keeping.
                </li>
                <li>
                  <strong>Deletion:</strong> In order to delete the personally identifiable
                  information including but not limited to the contact details, passwords among
                  other things that you submitted, you can notify us that you wish to delete your
                  personally identifiable information or any part thereof contained at our
                  databases.
                </li>
                <li>
                  <strong>Modification:</strong> If you wish to modify or update your personally
                  identifiable information, use the application interface.
                </li>
              </ul>
              <p className="italic text-xs text-slate-400">
                Please note that deletion of your personally identifiable information from the
                Company’s database will not prevent the Company from using gathered anonymous
                information.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white">8. Control on your information</h2>
              <p className="text-sm">
                You may control your account information by logging into your account and changing
                your personal information. You can also choose to stop receiving promotional email
                communications from us by clicking on the “unsubscribe link” provided in such
                communications or by writing to us on our mail. We make every effort to promptly
                process all unsubscribe requests. You may not opt out of Service-related
                communications (e.g., account verification, purchase and billing confirmations and
                reminders, changes/updates to features of the Service, technical and security
                notices).
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white">9. Third Party Links</h2>
              <p className="text-sm">
                Occasionally, at our discretion, we may include or offer third party products or
                services along with our services and products. These third-party sites have separate
                and independent privacy policies. We therefore have no responsibility or liability
                for the content and activities of these linked third-parties. Nonetheless, we seek
                to protect the integrity of our product and services, and welcome any feedback about
                these.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                <Clock className="w-6 md:h-6 text-indigo-400" />
                10. How long we keep your information
              </h2>
              <p className="text-sm">
                Following termination or deactivation of your User account, aiComposz will retain
                your profile information and User Content for a commercially reasonable time, and
                for as long as we have a valid purpose to do so. In particular, aiComposz will
                retain your information for the purpose of complying with its legal and audit
                obligations, and for backup and archival purposes.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white">11. Terms and Conditions</h2>
              <p className="text-sm">
                Please also visit our Terms and Conditions section establishing the use,
                disclaimers, and limitations of liability governing the use of our Website and which
                complements the Privacy Policy at www.aicomposz.com
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white">
                12. California users’ Privacy Rights
              </h2>
              <p className="text-sm">
                Californian users of aiComposz have additional rights afforded to them under the
                California Consumer Privacy Act (CCPA).
              </p>
              <h3 className="text-lg font-bold text-indigo-400">
                Categories of personal information collected by aiComposz
              </h3>
              <p className="text-sm">
                For more details about the personal information aiComposz has collected in the past
                year, please see section 1 “Information we collect and its use”. For details on how
                we use that information, and who we share it with, please see section 2 “How we use
                your information” and section 3 “Sharing your information”.
              </p>
              <p className="text-sm">
                aiComposz does not “sell” (as defined in the CCPA) the personal information of
                aiComposz users.
              </p>
              <h3 className="text-lg font-bold text-indigo-400">
                Making a request in relation to your personal information
              </h3>
              <p className="text-sm">
                The CCPA gives California consumers various rights with respect to the personal
                information we collect, including the right to (subject to certain limitations):
              </p>
              <ul className="list-disc pl-6 space-y-2 text-sm">
                <li>Request to access the personal information aiComposz has about you; and</li>
                <li>Request that aiComposz delete all of your personal information.</li>
              </ul>
              <p className="text-sm">
                California users may make a request by contacting us at team@aicomposz.com. We will
                authenticate your request using the email address associated with your aiComposz
                account and if necessary, proof of residency.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                <Scale className="w-6 md:h-6 text-emerald-400" />
                13. User Rights
              </h2>
              <p className="text-sm">
                Depending on the applicable law you may have the following rights in relation to
                your personal data:
              </p>
              <ul className="list-disc pl-6 space-y-4 text-sm">
                <li>Right to access your personal data being processed by us.</li>
                <li>
                  Right to rectify any discrepancy, inaccuracy in your personal data or complete any
                  incomplete details.
                </li>
                <li>Right to delete or remove your personal data in certain circumstances.</li>
                <li>
                  Right to restrict or object to processing of your personal data in certain
                  circumstances, such as data being used for marketing purposes or for any other
                  activities, we will comply with your request unless we have reasons for lawfully
                  retaining data about you. With respect to the right to withdraw your consent,
                  however, please note that exercise of any right will not affect the lawfulness of
                  processing based on your prior consent.
                </li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white">14. Change in Privacy Policy</h2>
              <p className="text-sm">
                We reserve the right to change this Privacy Policy at any time and if we decide to
                change our privacy policy, we will update the same on our website. Furthermore,
                please note that any changes made to this Privacy Policy are effective as of the
                stated “Last Updated” date, and your continued use of the Platform and Services
                after the Last Updated date will constitute acceptance of, and agreement to be bound
                by, those changes. If we make any material changes to the way we collect, use, store
                and/or share your personal information, we will notify you with a notice on our
                website and/by sending an email to the email address associated with your aiComposz
                account. We recommend that you check this page from time to time to inform yourself
                of any changes.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white">15. Applicable Law and Jurisdiction</h2>
              <p className="text-sm">
                By visiting this Platform, you agree that the laws of Delaware without regard to its
                conflict of laws principles govern this Privacy Policy and any dispute arising in
                respect out of or in relation to this Agreement shall be submitted to the sole
                jurisdiction of the courts of law at Delaware.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white">16. Be Vigilant and Circumspect</h2>
              <p className="text-sm">
                Even the best policy can't protect your online privacy and security in all
                circumstances. Unscrupulous advertisers, hackers, and scam artists are constantly
                searching the Internet looking for new targets. Your best protection is to
                understand the limits to privacy on the Internet and be vigilant in all of your
                online activities. Beware of scams in which persons unknown to you request your
                screen name, password, or credit card information. Make sure you verify the identity
                of anyone asking for personal information. Always monitor your children's online
                activities and educate them as to the rules for safe Internet use. As always, if you
                have any questions, please feel free to contact us with further questions.
              </p>
            </section>

            <section className="space-y-4 p-8 rounded-3xl bg-indigo-600/10 border border-indigo-500/20">
              <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                <Mail className="w-6 md:h-6 text-indigo-400" />
                17. Contact us
              </h2>
              <p className="text-sm">
                If you have any questions or concerns about this Privacy Policy or the Service, or
                wish to make a complaint please write to us at:{" "}
                <a
                  href="mailto:team@aicomposz.com"
                  className="text-indigo-400 hover:text-indigo-300 font-bold"
                >
                  team@aicomposz.com
                </a>
              </p>
              <p className="text-xs text-slate-500 mt-4">
                This statement of the aforementioned Privacy Policy is effective March 1st, 2026.
              </p>
            </section>
          </div>
        </div>

        <div className="px-6 py-6 md:px-8 md:py-6 border-t border-white/5 bg-slate-900/80 flex justify-end">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-8 py-3 bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs tracking-widest rounded-xl shadow-lg transition-all active:scale-95"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
